/* eslint-disable */
import * as React from 'react';
import { useEffect, useState } from 'react';
import { getPageSettingsData } from '../MandiMore/api/getPageSettingsData';
import { setPageSettingsData } from './setPageSettingsData';
import HomeSkeleton from '../MandiMore/components/HomeSkeleton';

import '../MandiMore/global.styles.scss';

export const Home = () => {
  const [view, setView] = useState(<HomeSkeleton />);

  useEffect(() => {
    window.routeInfo = {
      basePath: '/custom-flooring',
      choicePath: null
    };
    async function loadViews() {
      try {
        const { Render } = await import('../MandiMore/index');
        setView(<Render />);
      } catch (ex) {
        // eslint-disable-next-line no-console
        console.log('exception: ', ex);
      }
    }
    getPageSettingsData()
      .then(pagesettingsData => {
        setPageSettingsData(pagesettingsData);
        loadViews();
      })
      .catch((error) => console.error(error));

    // let url="";
    // if (process.env.RUNTIME_ENV === 'development')
    //     url=projectConfig.flooringBaseURL.dev;
    //  axios.get(`https://stage-custom.hd-qa74.homedepotdev.com/flooring/settings`).then((res)=>{
    //     const configSettings=toCamelCase(res.data);
    //     window.injectedConfiguratorSettings=configSettings.settings;
    //     window.productMetas=configSettings.meta;
    //     window.breadcrumbInfo=configSettings.thdBreadcrumbInfo.thdBreadcrumbs;
    //     window.featureGates=configSettings.featureGates;
    //     loadViews();
    //  });
  }, []);
  return <div className="container">{view}</div>;
};

Home.propTypes = {};

Home.displayName = 'HomePage';

Home.defaultProps = {
  name: ''
};
